import { computed, defineComponent, h } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import useCss from '@berlin-front/common/composables/useCss';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';

export default defineComponent({
  name: 'StyleOverrideContext',
  props: {
    value: {
      type: Object,
    },
  },
  setup(props, context) {
    const { themeParameter } = useContext(ThemeContext);
    const primaryColor = computed(() => themeParameter.value.primaryColor);

    useCss(
      // v-selectの選択リストのPrimary Colorを上書き
      () => `
        .v-select-list .v-list-item.primary--text {
          color: ${primaryColor.value} !important;
          caret-color: ${primaryColor.value} !important;
        }
      `,
    );

    return () => {
      if (context.slots.default) {
        const nodes = context.slots.default();
        if (nodes.length <= 1) {
          return nodes[0];
        }
        return h('div', {}, nodes);
      }
      return undefined;
    };
  },
});
